import React from "react";
import "./outreach.css";
import baptismImage from "../assets/OutReachMission/baptism.png";
import congregationImage from "../assets/OutReachMission/group.png";

const OutreachHealing = () => {
  return (
    <section className="outreach-wrapper" id="outreach">
      <div className="outreach-header has-text-white has-text-centered">
        <h1 className="title is-3 has-text-white">OUTREACH AND HEALING</h1>
      </div>

      <div className="is-fluid">
        <div className="columns is-multiline is-gapless">
          {/* Top Left - Vision */}
          <div className="column is-half-tablet is-full-mobile">
            <div className="is-flex is-flex-direction-column is-justify-content-center vision-box p-5 has-background-black has-text-white">
              <div className="py-6">
              <h2 className="title is-2">Our Vision</h2>
              <p>
                Declaration Church exists to develop disciples who will declare
                and demonstrate the Gospel to Bryan/College Station and beyond.
              </p>
              </div>
            </div>
          </div>

          {/* Top Right - Baptism Image */}
          <div className="column is-half-tablet is-full-mobile">
            <img
              src={baptismImage}
              alt="Baptism"
              className="img-block is-100%"
              style={{ objectFit: "cover", height: "auto" }}
            />
          </div>

          {/* Bottom Left - Congregation Image */}
          <div className="column is-half-tablet is-full-mobile">
            <img
              src={congregationImage}
              alt="Congregation"
              className="img-block is-100%"
              style={{ objectFit: "cover", height: "auto" }}
            />
          </div>

          {/* Bottom Right - Podcast */}
          <div className="column is-half-tablet is-full-mobile">
            <div className="podcast-box p-5 has-background-white is-flex is-flex-direction-column is-justify-content-center">
              <h2 className="title is-2 has-text-black">Podcast</h2>
              <p className="has-text-black is-justified">
                Want to stay up to date with the preaching and teaching at
                Declaration Church? You can do so by listening to our podcast,
                available by searching "Declaration Church" on your favorite
                streaming app or by clicking the link below to listen online!
              </p>
              <button className="button is-outlined mt-4 has-text-black">LISTEN NOW</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OutreachHealing;
